import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    actionsContainer: { display: 'flex', alignItems: 'center', gap: '8px' },
    tableLine: {
      fontSize: 12,
      cursor: 'pointer',
      color: palette.darkGray,
    },
    envsToExpire: {
      border: `1px solid ${palette.red}`,
      color: palette.red,
      fontSize: 12,
    },
    divider: { width: '100%', marginTop: '16px' },
    searchContainer: { alignItems: 'center', justifyContent: 'space-between' },
    summaryRowTable: {
      backgroundColor: `${palette.white} !important`,
      height: '20px !important',

      '& .MuiTableCell-root': {
        padding: 0,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        cursor: 'pointer',
      },
    },
    envRow: {
      backgroundColor: `${palette.lightYellow} !important`,
      height: '20px !important',
      cursor: 'pointer',

      '& .MuiTableCell-root': {
        padding: 0,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
      },
    },
    centerFields: {
      textAlign: 'center',
      fontSize: 12,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    accessButton: {
      fontSize: 15,
      color: palette.blue,
    },
    longNameField: {
      '& .MuiTypography-root': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: 280,
        padding: '0 16px',
      },
    },
    textAndIcon: {
      color: palette.darkGray,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      whiteSpace: 'nowrap',
      marginRight: 10,

      '& svg': {
        fontSize: 15,
        marginRight: 10,
      },
    },
    numberFields: {
      textAlign: 'center',
      fontSize: 12,
      color: palette.darkGray,
    },
    dateField: {
      fontSize: 12,
      whiteSpace: 'nowrap',
      '& > div': {
        justifyContent: 'center',
      },
    },
    menuOptions: {
      fontSize: 12,
      fontWeight: 500,
    },
  });
